/*
I wrap {children} in a Link with no text-decoration
if {url} is present, otherwise I just return {children}
without modification.

If an alternative wrapping element is required in the case
of a missing {url}, a custom element can be chosen by
passing in the optional {element} prop.
*/

/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import styled from '@emotion/styled';
import { createElement } from 'react';

import Link from './oc-link';

const CleanLink = styled(Link)`
  position: relative;
  text-decoration: none;

  &:hover {
    color: inherit;
  }
`;

// legacyTheme is emotion's, not the DOM's: whatever is left in props here is handed to a real
// element below, and React writes an unknown prop out as an attribute rather than dropping it.
const WrapperLink = ({ url, children, element, analytics, legacyTheme: _legacyTheme, ...props }) => {
  const linkClasses = ['wrapper-link', props.className].filter(Boolean);

  if (url) {
    return (
      <CleanLink className={linkClasses.join(' ')} href={url} analytics={analytics} {...props}>
        {children}
      </CleanLink>
    );
  }
  if (element) {
    if (element === 'span') {
      // If the element is a span, I want to remove the aria-label prop,
      // as it is not valid on a span and will cause accessibility issues.
      // eslint-disable-next-line no-unused-vars
      const { 'aria-label': _, ...elementProps } = props;
      return createElement(element, elementProps, children);
    }
    return createElement(element, props, children);
  }
  return <>{children}</>;
};

export default WrapperLink;
/* eslint-enable react/prop-types */
